import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AppStateService } from "@services/index";

@Component({
  selector: "fh-loader",
  standalone: true,
  imports: [MatProgressSpinner, AsyncPipe],
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.scss",
})
export class LoaderComponent {
  constructor(public appStateService: AppStateService) {}
}
